/* src/app/shared/components/layout/burger-menu-modal/burger-menu-modal.component.scss */
:host {
  display: block;
}
menu {
  font-size: 1.2rem;
}
.burger-menu-dialog-close {
  position: absolute;
  left: 29px;
  z-index: 1;
  top: 15px;
}
/*# sourceMappingURL=burger-menu-modal.component.css.map */
